import { PlanSubmission } from "@/Utils/Plan/PlanSubmisionsTypes";
import { GetWSMgr } from "@/Utils/StateLib";
import { Globals } from "@coreapp/CoreApp/Globals";
import { QUpdatePlansRFC } from "@coreapp/CoreApp/QUpdatePlansRFC";
import { useCallback, useEffect, useState } from "react";
import { isNullish } from "@theorgchartdev/storybook";
import { useTopic } from "@/hooks/useTopic";
import { enumUpdatePlanModes } from "@coreapp/constants";

export const useFetchSubmissions = () => {
  const [planSubmissions, setPlanSubmissions] = useState<PlanSubmission[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchPlanSubmissions = useCallback(() => {
    const wsMgr = GetWSMgr();
    if (!wsMgr) return;

    const planMgr = wsMgr.fPlanManager;
    if (!planMgr) return;
    const planInfo = planMgr.GetPlanInfo();
    if (isNullish(planInfo?.ID)) return;

    setIsLoading(true);
    const requestData = {
      planID: planInfo.ID
    };
    const callBackObj = {
      onResult: (
        success: boolean,
        response: { submissions: PlanSubmission[]; message: string }
      ) => {
        setIsLoading(false);
        if (success) {
          setPlanSubmissions(response.submissions);
        } else {
          console.error("Failed to fetch plan submissions:", response.message);
        }
      },
      fWSMgr: wsMgr,
      UpdatePanel: () => {}
    };
    const rfc = new QUpdatePlansRFC();
    rfc.InitUpdatePlans(callBackObj);
    rfc.SetParams(
      wsMgr.GetAccountName(),
      wsMgr.GetUserName(),
      enumUpdatePlanModes.listPlanSubmissions,
      JSON.stringify(requestData)
    );

    Globals._rfcMgr.QueueRFC(rfc);
  }, []);

  useEffect(() => {
    fetchPlanSubmissions();
  }, []);

  // Listen for plan submission updates and refetch when they occur
  useTopic("planSubmissionUpdated", fetchPlanSubmissions);

  return { planSubmissions, isLoading };
};
